import clsx from 'clsx';

import { useIcon } from '~extension/icon-library/context/Icons';
import { LoadingCircle } from '../LoadingCircle';

export const IconCount = () => {
  const { hasLoaded, filteredIcons } = useIcon();
  const count = filteredIcons.length;

  if (!hasLoaded) {
    return (
      <div
        className={clsx(
          'icon-library--serachbar-count',
          `cursor-default flex items-center italic whitespace-no-wrap opacity-60`,
        )}
      >
        <LoadingCircle />
      </div>
    );
  }

  return (
    <div
      className={clsx(
        'icon-library--searchbar-count',
        `cursor-default flex items-center italic whitespace-no-wrap opacity-60`,
      )}
    >{`${count} ${count === 1 ? 'icon' : 'icons'}`}</div>
  );
};
